export default "__VITE_ASSET__CEb29YFO__"